import { Box } from "@chakra-ui/react";

import { MaplibreLegend, MaplibreLegendLayer } from "@nens/ranalib";

import { VectorFileDescriptor } from "@/types/descriptor-types";

import { CompleteFile } from "../../../types/file-reference-with-file";
import { VectorLayer } from "../../../types/publication";
import { usePublicationVectorStylingOptions } from "../../map-layers";
import { LEGEND_ITEM_GAP } from "../consts/legend-item-gap";

import { LegendLabel } from "./legend-label";

type VectorLegendProps = {
  layer: VectorLayer;
  file: CompleteFile;
  mapId: string;
};

export function VectorLegend({ layer, file, mapId }: VectorLegendProps) {
  const vectorDescriptorLayers = usePublicationVectorStylingOptions([
    { fileDescriptor: file.file.descriptor as VectorFileDescriptor, layer },
  ]);

  if (!vectorDescriptorLayers || vectorDescriptorLayers.length === 0) {
    return null;
  }

  // Transform VectorDescriptorLayer[] to MaplibreLegendLayer[]
  const legendLayers = vectorDescriptorLayers
    .map(({ layer, styleLayers, type }) => ({ layer, styleLayers, type }))
    .filter((l): l is MaplibreLegendLayer => l.styleLayers !== undefined);
  if (legendLayers.length === 0) return null;

  return (
    <Box mb={LEGEND_ITEM_GAP}>
      <LegendLabel layer={layer} file={file} />
      <MaplibreLegend ignoreGrouping layers={legendLayers} mapId={mapId} />
    </Box>
  );
}
